export enum ContentBlockLayout {
  Normal = 'normal',
  Compact = 'compact',
}

export interface IContentBlockControl {
  layout: ContentBlockLayout;
}
